module.exports = __webpack_public_path__ + "img/交易台.6531653a.png";